module.exports = __webpack_public_path__ + "img/medication-quantity.c8844b04.svg";